'use client';

import { useEffect } from 'react';

export default function HomepagePixelEvents() {
  useEffect(() => {
    // Meta Pixel - Homepage View
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('trackCustom', 'HomepageView');
    }
  }, []);

  return null;
}
